import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'reminders-modal',
    templateUrl: './reminders-modal.component.html',
    styleUrls: ['./reminders-modal.component.scss']
})
export class RemindersModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    step = 'details';
    data = {
        title: '',
        description: '',
        conditionDefinition: {
            value: null,
            name: '',
            isAfter: false
        },
        enableStatus: true,
        forStaff: true,
        conditionField: '',
        subject: '',
        template: '',
        userRoles: []
    };
    timingSelectValues = [
        {value: 'minute', displayName: 'Minutes'},
        {value: 'hour', displayName: 'Hours'},
        {value: 'day', displayName: 'Days'}
    ];
    conditionFieldsSelectValues = [
        {value: 'dateFrom', displayName: 'Start Date'},
        {value: 'dateTo', displayName: 'End Date'}
    ];
    placeholders = [
        '[[AMENITY]]',
        '[[START_DATE]]',
        '[[END_DATE]]',
        '[[STAFF_MEMBER_NAME]]',
        '[[RESIDENT_NAME]]',
        '[[UNIT_NUMBER]]',
        '[[BOOKING_ID]]',
        '[[BUILDING_NAME]]',
        '[[NOTES]]',
        '[[CREATED_BY]]',
        '[[CREATED_ON]]',
        '[[AMENITY_STATUS]]',
        '[[MY_SIGNATURE]]'
    ];
    showUsersSpinner = false;
    users: Array<any> = [];
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };

    constructor(
        public api: ApiClientService,
        public settingsAmenitiesService: SettingsAmenitiesService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.getUsers();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsAmenitiesService.selectedReminderIndex !== null) {
            const item = this.settingsAmenitiesService.selectedItemData.reminders[this.settingsAmenitiesService.selectedReminderIndex];
            this.data = {
                title: item.title,
                description: item.description,
                conditionDefinition: {
                    value: item.conditionDefinition.value,
                    name: item.conditionDefinition.name,
                    isAfter: item.conditionDefinition.isAfter
                },
                conditionField: item.conditionField,
                forStaff: item.forStaff,
                enableStatus: item.enableStatus,
                subject: item.subject,
                template: item.template,
                userRoles: item.userRoles.map(u => ({
                    id: u.bdId,
                    itemName: u.roleName
                }))
            };
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsAmenitiesService.isRemindersModalShow = false;
                    this.settingsAmenitiesService.selectedReminderIndex = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsAmenitiesService.isRemindersModalShow = false;
            this.settingsAmenitiesService.selectedReminderIndex = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        this.disabledSubmit = true;
        const data = {reminders: this.getRemindersFormatted()};
        const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json`;
        this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => {
                this.disabledSubmit = false;
                this.updateView('The Field was successfully updated');
            }, error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Update failed!');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsAmenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    moveToTheNextStep(moveTo): void {
        this.step = moveTo;
        if(this.step == 'notification')
            setTimeout( () => this.initSummernote(), 300);
    }

    calculateCurrentProgressBarLength(): string {
        let width = '17%';

        if(this.step == 'conditions')
            width = '50%';
        else if(this.step == 'notification')
            width = '83%';

        return width;
    }

    isContinueButtonDisabled(step): boolean {
        let isDisabled = false;
        if(step == 'details') {
            if(!this.data.title || !this.data.description)
                isDisabled = true;
        } else if(step == 'conditions') {
            if(!this.data.conditionDefinition.value || !this.data.conditionDefinition.name ||
               !this.data.conditionField || !(/^[0-9]*$/.test(this.data.conditionDefinition.value)))
                isDisabled = true;
        } else if(step == 'notification') {
            if(!this.data.subject || !this.data.template)
                isDisabled = true;
        }
        return isDisabled;
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.data.template = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['help', ['help']],
                ['table', ['table']],
                ['insert', ['link', 'hr']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle" 
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.data.template).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.data.template).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    getRemindersFormatted() {
        let data = [];
        this.data.userRoles = this.data.userRoles.map(u => ({
            ...u,
            bdId: u.id,
            roleName: u.name || u.roleName || u.itemName
        }));
        if(this.settingsAmenitiesService.selectedItemData.reminders.length > 0) {
            if(this.settingsAmenitiesService.selectedReminderIndex === null)
                data = this.settingsAmenitiesService.selectedItemData.reminders.concat(this.data);
            else {
                this.settingsAmenitiesService.selectedItemData.reminders.splice(this.settingsAmenitiesService.selectedReminderIndex, 1, this.data);
                data = this.settingsAmenitiesService.selectedItemData.reminders;
            }
        } else {
            data = [this.data];
        }

        return data.map(item => ({
            title: item.title,
            description: item.description,
            conditionDefinition: {
                value: item.conditionDefinition.value,
                name: item.conditionDefinition.name,
                isAfter: item.conditionDefinition.isAfter
            },
            conditionField: item.conditionField,
            subject: item.subject,
            template: item.template,
            forStaff: item.forStaff,
            enableStatus: item.enableStatus,
            userRoles: !item.forStaff ? [] : item.userRoles.map(u => ({
                bdId: u.bdId,
                roleName: u.roleName
            }))
        }));
    }

    getUsers() {
        this.showUsersSpinner = true;
        const url = `/api/v1/role.json?per-page=10000`;
        this.api.get('oauthUrl', url).subscribe(res => {
                const body = JSON.parse(res._body);
                this.users = body.entities || [];
                this.users = this.users.map(u => ({
                    ...u,
                    itemName: u.name
                }));
            }, error => this.api.errorHandler(error, 'Failed get Users'),
            () => this.showUsersSpinner = false);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/reminders-modal/reminders-modal.component.ts